export const singleModuleTranslations = {
  en: {
    hero: {
      badge: 'Pay Per Module',
      title: 'Pay Per Module',
      subtitle: 'Perfect for focused learning on specific topics'
    },
    content: {
      badge: '📚 Flexible Learning',
      description: 'Get access to individual modules without committing to the full program. Perfect for those who want to learn specific skills at their own pace.'
    },
    features: {
      title: 'What\'s Included',
      items: [
        {
          title: 'Choose Any Module',
          description: 'Pick any module from Full Program and study it separately at your own convenience'
        },
        {
          title: 'Learn at Your Own Pace',
          description: 'No deadlines, no pressure — take your time and master each topic thoroughly'
        },
        {
          title: 'Practice Projects',
          description: 'Hands-on projects to apply what you\'ve learned'
        },
        {
          title: 'Community Support',
          description: 'Access to our learning community for questions and discussions'
        }
      ]
    },
    pricing: {
      title: 'Module Pricing',
      perModule: 'per module',
      startingFrom: 'Starting from',
      selectModule: 'Select a Module'
    },
    modules: {
      title: 'Available Modules',
      basics: {
        name: 'UI Basics',
        description: 'Learn the fundamentals of user interface design'
      },
      architecture: {
        name: 'Product Architecture',
        description: 'Understand how to structure digital products'
      },
      aiTools: {
        name: 'AI Tools Mastery',
        description: 'Master AI-powered development tools'
      },
      deployment: {
        name: 'Deployment & Launch',
        description: 'Learn how to deploy and launch your products'
      }
    },
    cta: {
      goToDashboard: 'Go to Dashboard',
      backToHome: 'Back to Home',
      buyModule: 'Buy This Module',
      viewAllModules: 'View All Modules'
    }
  },
  uk: {
    hero: {
      badge: 'Оплата за модуль',
      title: 'Оплата за модуль',
      subtitle: 'Ідеально для фокусного навчання на конкретних темах'
    },
    content: {
      badge: '📚 Гнучке навчання',
      description: 'Отримайте доступ до окремих модулів без зобов\'язань щодо повної програми. Ідеально для тих, хто хоче вивчати конкретні навички у власному темпі.'
    },
    features: {
      title: 'Що включено',
      items: [
        {
          title: 'Обери будь-який модуль',
          description: 'Вибери будь-який модуль з Full Program і вивчай його окремо від усієї програми'
        },
        {
          title: 'Рухайся у своєму темпі',
          description: 'Без дедлайнів, без тиску — не поспішай і опановуй кожну тему ґрунтовно'
        },
        {
          title: 'Практичні проекти',
          description: 'Практичні проекти для застосування вивченого'
        },
        {
          title: 'Підтримка спільноти',
          description: 'Доступ до нашої навчальної спільноти для запитань та обговорень'
        }
      ]
    },
    pricing: {
      title: 'Ціни на модулі',
      perModule: 'за модуль',
      startingFrom: 'Починаючи від',
      selectModule: 'Оберіть модуль'
    },
    modules: {
      title: 'Доступні модулі',
      basics: {
        name: 'Основи UI',
        description: 'Вивчіть основи дизайну користувацького інтерфейсу'
      },
      architecture: {
        name: 'Архітектура продукту',
        description: 'Зрозумійте як структурувати цифрові продукти'
      },
      aiTools: {
        name: 'Майстерність AI інструментів',
        description: 'Опануйте інструменти розробки на базі AI'
      },
      deployment: {
        name: 'Деплоймент та запуск',
        description: 'Навчіться розгортати та запускати ваші продукти'
      }
    },
    cta: {
      goToDashboard: 'Перейти до панелі',
      backToHome: 'На головну',
      buyModule: 'Купити цей модуль',
      viewAllModules: 'Переглянути всі модулі'
    }
  }
};
